import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import consumerNo from "../../assets/images/consumerNo.svg";
import divMarker from "../../assets/images/divMarker.svg";
import recharge from "../../assets/images/recharge.svg";
import mobile from "../../assets/images/mobile.svg";
import email from "../../assets/images/email.svg";
import apiAuth from "../../helpers/ApiAuth";
import NotificationManager from "../../components/Common/NotificationManager";
import API from "../../helpers/API";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const customStyles = {
  control: (styles, { isFocused, isHovered }) => ({
    ...styles,
    border: "none",
    borderBottom: `1px solid ${isFocused || isHovered ? "#26a69a" : "#9e9e9e"}`,
    borderRadius: "0",
    background: "transparent",
    paddingLeft: "10px",
    boxShadow: "none",
    "&:hover": {
      borderBottom: `1px solid #9e9e9e`,
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
};

const FormPreview = (props) => {
  const [selRecharge, setSelRecharge] = useState(null);
  const [loading, setLoading] = useState(false);
  const { consumerData, rechargeOptions } = props;
  const formikRef = useRef();
  const history = useHistory();

  const handlePaySubmit = (values) => {
    console.log("values", values);

    // Check if the encryption API call should be made
    if (!loading) {
      setLoading(true);

      let objToSent = {
        consumerNo: values?.consumer,
        amount: values?.recharge,
        consumerName: consumerData?.consumername,
        consumerMobile: values?.mobile,
      };

      API.post(`/api/Consumer/InitiatePayment`, objToSent)
        .then((res) => {
          console.log("responseee", res);
          const data = res?.data;
          localStorage.setItem("initiateResponse", JSON.stringify(data));
          console.log("data", data);
          const {
            encryptTrans,
            merchIdVal,
            multiAccountInstructionDtls,
            transactionId,
          } = data || {};

          const form = document.getElementById("frmPost");

          // send details to API and get below values
          form.EncryptTrans.value = encryptTrans;

          form.MultiAccountInstructionDtls.value = multiAccountInstructionDtls;
          form.merchIdVal.value = merchIdVal;
          form.action =
            "https://www.sbiepay.sbi/secure/AggregatorHostedListener";
          // "https://test.sbiepay.sbi/secure/AggregatorHostedListener";
          form.submit();

          setLoading(false);
        })
        .catch((err) => {
          console.log("error", err?.response);

          setLoading(false);

          NotificationManager.error(
            "Consumer details",
            "Consumer Encrypt error",
            3000,
            null,
            null,
            ""
          );
        });
    }
  };

  return (
    <div>
      <Formik
        innerRef={formikRef}
        id="frmPost"
        initialValues={{
          division: consumerData?.division,
          consumer: consumerData?.consumerno,
          recharge: "",
          mobile: consumerData?.phone,
          email: consumerData?.email,
        }}
        validationSchema={Yup.object({
          recharge: Yup.string().required("Required!"),
          mobile: Yup.string()
            .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
            .required("Mobile number is required"),
        })}
        onSubmit={handlePaySubmit}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form className="av-tooltip tooltip-label-bottom">
            <Grid>
              {/* Division and Consumer Number */}
              <Grid container spacing={2}>
                <Grid item lg={6} xs={12} className="mt-2 mb-2">
                  <div className="mb-3">
                    <label
                      htmlFor="division"
                      className="form-label"
                      style={{
                        color: "#9e9e9e",
                        fontSize: "14px",
                      }}
                    >
                      Which division are you in
                      <span className="text-danger">*</span>
                    </label>
                    <div className="input-container position-relative">
                      <Field
                        className="form-control"
                        name="division"
                        placeholder="Division"
                        style={{
                          borderRadius: "0",
                          border: "none",
                          borderBottom: "1px solid #9e9e9e",
                          background: "transparent",
                          paddingLeft: "20px",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.borderColor = "#26a69a")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.borderColor = "#9e9e9e")
                        }
                        onClick={(e) =>
                          (e.target.style.borderColor = "#26a69a")
                        }
                        disabled
                      />
                      <div
                        className="icon-container position-absolute"
                        style={{ bottom: "8px" }}
                      >
                        <img src={divMarker} alt="" />
                      </div>
                    </div>
                    <ErrorMessage
                      name="division"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                </Grid>

                <Grid item lg={6} xs={12} className=" mt-2 mb-2">
                  <div className="mb-3">
                    <label
                      htmlFor="consumer"
                      className="form-label"
                      style={{
                        color: "#9e9e9e",
                        fontSize: "14px",
                      }}
                    >
                      Please enter your Consumer No or Meter No
                      <span className="text-danger">*</span>
                    </label>
                    <div className="input-container position-relative">
                      <Field
                        className="form-control"
                        name="consumer"
                        placeholder="Consumer Number"
                        style={{
                          borderRadius: "0",
                          border: "none",
                          borderBottom: "1px solid #9e9e9e",
                          background: "transparent",
                          paddingLeft: "20px",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.borderColor = "#26a69a")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.borderColor = "#9e9e9e")
                        }
                        onClick={(e) =>
                          (e.target.style.borderColor = "#26a69a")
                        }
                        disabled
                      />
                      <div
                        className="icon-container position-absolute"
                        style={{ bottom: "8px" }}
                      >
                        <img src={consumerNo} alt="" />
                      </div>
                    </div>
                    <ErrorMessage
                      name="consumer"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                </Grid>
              </Grid>

              {/* Recharge Amount & Mobile Number */}
              <Grid container spacing={2}>
                <Grid item lg={6} xs={12} className="mt-2 mb-2">
                  <div className="mb-3">
                    <label
                      htmlFor="recharge"
                      className="form-label"
                      style={{
                        color: "#000",
                        fontSize: "14px",
                      }}
                    >
                      Please enter the recharge amount
                      <span className="text-danger">*</span>
                    </label>
                    <div className="input-container position-relative">
                      <Select
                        options={rechargeOptions}
                        value={selRecharge}
                        onChange={(data) => {
                          setFieldValue("recharge", data?.value);
                          setSelRecharge(data);
                        }}
                        styles={customStyles}
                      />
                      <div
                        className="icon-container position-absolute"
                        style={{ bottom: "8px" }}
                      >
                        <img src={recharge} alt="" />
                      </div>
                    </div>
                    <ErrorMessage
                      name="recharge"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                </Grid>
                <Grid item lg={6} xs={12} className="mt-2 mb-2">
                  <label
                    htmlFor="mobile"
                    className="form-label"
                    style={{
                      color: "#000",
                      fontSize: "14px",
                    }}
                  >
                    Please enter your Mobile No
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-container position-relative">
                    <Field
                      className="form-control"
                      name="mobile"
                      placeholder="Mobile Number"
                      style={{
                        borderRadius: "0",
                        border: "none",
                        borderBottom: "1px solid #9e9e9e",
                        paddingLeft: "20px",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.borderColor = "#26a69a")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.borderColor = "#9e9e9e")
                      }
                      onClick={(e) => (e.target.style.borderColor = "#26a69a")}
                    />
                    <div
                      className="icon-container position-absolute"
                      style={{ bottom: "8px" }}
                    >
                      <img src={mobile} alt="" />
                    </div>
                  </div>
                  <ErrorMessage
                    name="mobile"
                    render={(msg) => <div className="text-danger">{msg}</div>}
                  />
                </Grid>
              </Grid>

              {/* Email */}
              <Grid container spacing={2}>
                <Grid item lg={6} xs={12} className="mb-2">
                  <label
                    htmlFor="email"
                    className="form-label"
                    style={{
                      color: "#000",
                      fontSize: "14px",
                    }}
                  >
                    Please enter your email
                  </label>
                  <div className="input-container position-relative">
                    <Field
                      className="form-control"
                      name="email"
                      placeholder="Email..."
                      style={{
                        borderRadius: "0",
                        border: "none",
                        borderBottom: "1px solid #9e9e9e",
                        paddingLeft: "20px",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.borderColor = "#26a69a")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.borderColor = "#9e9e9e")
                      }
                      onClick={(e) => (e.target.style.borderColor = "#26a69a")}
                    />
                    <div
                      className="icon-container position-absolute"
                      style={{ bottom: "8px" }}
                    >
                      <img src={email} alt="" />
                    </div>
                  </div>
                  <ErrorMessage
                    name="email"
                    render={(msg) => <div className="text-danger">{msg}</div>}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Buttons */}

            <Grid container spacing={2} className="mt-2">
              <Grid item lg={2}>
                <Button
                  fullWidth
                  className="btn my-2"
                  onClick={props.handleBackButton}
                  style={{
                    color: "black",
                    fontWeight: 500,
                    fontSize: "15px",
                    background: "#D3D3D3",
                    borderRadius: "5px",
                    boxShadow:
                      "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                    textTransform: "capitalize",
                  }}
                  onMouseOver={(e) => (e.target.style.background = "darkgrey")}
                  onMouseOut={(e) => (e.target.style.background = "lightgrey")}
                >
                  Go Back
                </Button>
              </Grid>
              {loading ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <Grid item lg={2}>
                  <Button
                    fullWidth
                    className="btn my-2"
                    type="submit"
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      background:
                        "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                      borderRadius: "5px",
                      boxShadow:
                        "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                      textTransform: "capitalize",
                    }}
                  >
                    Pay Now
                  </Button>
                </Grid>
              )}
            </Grid>
            <Grid>
              <span className="text-danger font-weight-bold h6 my-2">
                *Please Note:
              </span>{" "}
              <br></br>1. Pay via UPI, Netbanking or Rupay Debit cards only{" "}
              <br></br>2. ⁠All payments final and non refundable
            </Grid>
          </Form>
        )}
      </Formik>
      <div>
        {" "}
        <form id="frmPost" method="post">
          <input type="hidden" name="EncryptTrans" value="" />
          <input type="hidden" name="merchIdVal" value="" />
          <input type="hidden" name="MultiAccountInstructionDtls" value="" />
        </form>{" "}
      </div>
    </div>
  );
};

export default FormPreview;
